import { useRef } from 'react';
import styled from 'styled-components';
import { ShowMore, ShowMoreRef, ShowMoreToggleLinesFn } from '@re-dev/react-truncate';

import { LabelBold } from '@comeon/ui';

const AboutContainer = styled.div`
	padding: 12px;
	border-radius: 12px;
	background-color: var(--game-info-card-color);
	margin-bottom: 12px;
`;

const Title = styled(LabelBold)`
	margin-bottom: 12px;
	color: var(--game-info-row-value-text-color);
`;

const ShowMoreStyled = styled(ShowMore)`
	color: rgba(var(--font-supportive), 1);
	font: var(--caption);
`;

const MoreButton = styled.span`
	color: rgba(var(--info));
	font: var(--caption);
	cursor: pointer;
`;

const Elapses = styled.span`
	color: rgba(var(--font-supportive), 1);
	font: var(--caption);
	cursor: pointer;
`;

const About = ({
	text,
	gameName,
	title,
	moreText,
	lessText
}: {
	text: string;
	gameName: string;
	title: string;
	moreText: string;
	lessText: string;
}) => {
	const ref = useRef<ShowMoreRef>(null);

	const toggleLines: ShowMoreToggleLinesFn = e => {
		ref.current?.toggleLines(e);
	};

	return (
		<AboutContainer>
			<Title>{`${title} ${gameName}`}</Title>
			<ShowMoreStyled
				ref={ref}
				lines={3}
				more={
					<MoreButton onClick={toggleLines}>
						<Elapses>...</Elapses> {moreText}
					</MoreButton>
				}
				less={<MoreButton onClick={toggleLines}> {lessText}</MoreButton>}
			>
				{text}
			</ShowMoreStyled>
		</AboutContainer>
	);
};

export default About;
